import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todas as fazendas cadastradas no banco de dados
 */
const getAllFazendas = async () => {
	return registryApi.get('v2/Fazenda')
}

/**
 * Retorna todas as fazendas estruturadas para o componente de DropdownFk
 */
const getDropdownFazendas = async () => {
	const result = await registryApi.get('v2/Fazenda/lista-dropdown')
	return result.data.map((fazenda) => {
		return {
			id: fazenda.id,
			[i18n.t('code')]: fazenda.fzda_cd_codigo,
			[i18n.t('name')]: fazenda.fzda_nm_nome,
			[i18n.t('description')]: fazenda.fzda_ds_descricao,
		}
	})
}

/**
 * Cadastrar nova fazenda no banco de dados
 * @param {Object} body Fazenda que será cadastrada
 */
const createFazenda = async (body) => {
	return registryApi.post('v2/Fazenda', body)
}

/**
 * Atualiza fazenda no banco de dados
 * @param {Object} body Fazenda que será atualizada
 */
const updateFazenda = async (body) => {
	return registryApi.put('v2/Fazenda', body)
}

/**
 * Lista dos ids de fazenda que devem ser excluidos do banco de dados
 * @param {Array} body Lista dos ids de fazenda
 */
const deleteFazendaByIdList = async (data) => {
	return registryApi.delete('v2/Fazenda/exclui-todos-por-lista-ids', { data })
}

/**
 * Retorna todas as fazendas estruturadas para o componente ButtonDropdown
 */
const getAllFazendasComInventarioFlorestalDropdown = async () => {
	const result = await registryApi.get(
		'v2/Fazenda/lista-fazendas-com-inventario-florestal-dropdown',
	)
	const dropdown = result.data.map((fazenda) => {
		return {
			label: fazenda.fzda_nm_nome,
			value: fazenda.id,
		}
	})

	dropdown.unshift({ label: i18n.t('selectFarm'), value: '' })

	return dropdown
}

/**
 * Retorna fazendas com uma flag dizendo que esta fazenda possui plantios disponiveis para estratos tradicionais
 */
export const getFazendasParaEstratoFlorestalDropdown = async () => {
	const result = await registryApi.get('v2/Fazenda/lista-fazendas-para-estrato-florestal-dropdown')
	return result.data.map((fazenda) => {
		return {
			id: fazenda.id,
			[i18n.t('code')]: fazenda.fzda_cd_codigo,
			[i18n.t('name')]: fazenda.fzda_nm_nome,
			[i18n.t('description')]: fazenda.fzda_ds_descricao,
			FazendaComPlantiosDisponiveis: !fazenda.fazendaComPlantiosDisponiveis,
		}
	})
}

export const importShapeFazenda = async (data) => {
	return registryApi.post('v1/Gis/ImportaFazendaGeojson', data)
}

export const importShapeTalhao = async (data) => {
	return registryApi.post('v1/Gis/ImportaTalhaoGeojson', data)
}
export const importShapePlantio = async (data) => {
	return registryApi.post('v1/Gis/ImportaPlantioGeojson', data)
}

export const getAllShapesByFazendaId = async (fazendaId) => {
	return registryApi.get(`v1/Gis/GetAllMapsByFazendaId?fazendaId=${fazendaId}`)
}

export {
	getAllFazendas,
	getDropdownFazendas,
	createFazenda,
	updateFazenda,
	deleteFazendaByIdList,
	getAllFazendasComInventarioFlorestalDropdown,
}
